export function ApiRequestError({ error }: { error: any }) {
  return (
    <div className="text-sm bg-red-200 text-red-700 rounded border border-red-500 p-4">
      <p>Ocorreu um erro ao buscar as informações.</p>
      { process?.env?.NODE_ENV === 'development' ? <pre className="mt-8 whitespace-pre-line">{JSON.stringify(error)}</pre> : ''}
    </div>
  );
}
